import { defaultStoreUtils } from '@databases/redux';
import { deselectAll } from '@databases/redux/cellSelections/actions';
import { useEffect } from 'react';

export const useDeselectOnStreaming = (isStreaming: boolean): void => {
  const dispatch = defaultStoreUtils.useDispatch();

  useEffect(() => {
    if (isStreaming) {
      dispatch(deselectAll());
    }
  }, [dispatch, isStreaming]);
};
